import React from "react"
import styled from "styled-components"

export const Information = styled.section`
  max-width: 1120px;
  margin: 0 auto;
  padding: 56px 24px;
  color: #021f4b;
  font-size: 18px;
  line-height: 1.65;
  h1 {
    font-size: clamp(32px, 5vw, 52px);
    line-height: 1.15;
    margin: 0 0 24px;
  }
  h2 {
    font-size: 28px;
    line-height: 1.3;
    margin: 32px 0 16px;
  }
  p {
    margin: 0 0 20px;
  }
  a {
    color: #021f4b;
    text-decoration: underline;
  }
  a:focus-visible,
  button:focus-visible {
    outline: 3px solid #0068cc;
    outline-offset: 4px;
  }
  ul {
    padding-left: 24px;
  }
  li {
    margin-bottom: 12px;
  }
`

const Notice = styled.aside`
  padding: 24px 24px 64px;
  background: #f4f6f9;
  color: #021f4b;
  font-size: 14px;
  line-height: 1.6;
  p {
    max-width: 1120px;
    margin: 0 auto 12px;
  }
  a {
    color: inherit;
    text-decoration: underline;
  }
  a:focus-visible {
    outline: 3px solid #0068cc;
    outline-offset: 4px;
  }
`

export const PublicSiteNotice = () => (
  <Notice aria-label="Website information">
    <p>
      This public website provides company and property information. It does not
      offer securities or invite subscriptions to an investment. Project
      examples describe development activity and are not statements of
      investment availability or future performance.
    </p>
    <p>
      Private investments involve risk, including loss of capital and limited
      liquidity. Any offering is made separately through applicable offering
      documents and an appropriate investor qualification process. Contacting
      Exdev or viewing this website does not establish eligibility or a
      pre-existing substantive relationship.
    </p>
    <p>
      <a href="/en/privacy">Privacy and California rights</a>
      {" · "}
      <a href="/en/terms">Terms</a>
      {" · "}
      <a href="/en/contact">Contact and accessibility assistance</a>
      {" · "}
      <a href="https://investors.appfolioim.com/exdev/investor/login">
        Existing investor login
      </a>
    </p>
  </Notice>
)

export const CollectionNotice = () => (
  <Information aria-label="Privacy notice for enquiries">
    <h2>Before contacting us</h2>
    <p>
      We use the name, contact details and message you provide to respond to
      your enquiry and manage our business relationship. Do not send Social
      Security numbers, bank details, passwords or identity documents through a
      general enquiry.
    </p>
    <p>
      We retain correspondence as needed to handle the enquiry and related legal
      or record-keeping obligations. We do not sell personal information or
      share it for cross-context behavioral advertising. See our{" "}
      <a href="/en/privacy">Privacy Notice</a> for service-provider disclosures,
      retention criteria and your California privacy rights.
    </p>
    <p>
      General enquiries do not provide access to an investment offering or
      establish investor qualification.
    </p>
    <h2>Accessibility assistance</h2>
    <p>
      If you have difficulty accessing any page, document or video, email{" "}
      <a href="mailto:info@exdev.com">info@exdev.com</a> or call{" "}
      <a href="tel:+16263845050">626-384-5050</a>. Tell us which content you
      need and your preferred way to receive it.
    </p>
  </Information>
)
